// extracted by mini-css-extract-plugin
export default {"modalBodyStyle":"setup_modalBodyStyle__yIuBI","modal":"setup_modal__W2w7-"};